const bn = {
  nav: {
    home: "হোম",
    salons: "স্যালন",
    membership: "সদস্যপদ",
    shop: "শপ",
    academy: "অ্যাকাডেমি",
    blog: "জার্নাল",
    login: "লগইন",
    logout: "লগ আউট",
    dashboard: "ড্যাশবোর্ড",
    bookings: "আমার বুকিং",
    loyalty: "লয়্যালটি",
    profile: "প্রোফাইল",
    orders: "আমার অর্ডার",
    chat: "কথোপকথন",
    notifications: "বিজ্ঞপ্তি",
    partner: "পার্টনার",
    admin: "অ্যাডমিন",
    partner_panel: "পার্টনার প্যানেল",
    admin_panel: "অ্যাডমিন প্যানেল",
    login_register: "লগইন / রেজিস্টার",
    skip_to_content: "কনটেন্টে যান",
    account_menu: "অ্যাকাউন্ট মেনু",
    primary_nav: "প্রাইমারি",
    mobile_nav: "মোবাইল নেভিগেশন",
    ai_advisor: "AI উপদেষ্টা",
    cart: "শপিং কার্ট",
  },
  footer: {
    tagline: "ভারতের প্রিমিয়াম স্যালন বুকিং প্ল্যাটফর্ম — বিলাসবহুল সৌন্দর্য এখন আপনার হাতের মুঠোয়।",
    company: "কোম্পানি",
    about: "আমাদের সম্পর্কে",
    how_it_works: "এটি কীভাবে কাজ করে",
    partners: "পার্টনারদের জন্য",
    stylists: "স্টাইলিস্টদের জন্য",
    careers: "ক্যারিয়ার",
    contact: "যোগাযোগ",
    support: "সহায়তা",
    faq: "প্রশ্নোত্তর",
    help: "সহায়তা কেন্দ্র",
    privacy: "গোপনীয়তা নীতি",
    terms: "সেবার শর্তাবলী",
    refund: "রিফান্ড নীতি",
    services: "পরিষেবা",
    salons: "স্যালন",
    membership: "সদস্যপদ",
    shop: "শপ",
    academy: "অ্যাকাডেমি",
    connect: "সংযোগ",
    newsletter_title: "আমাদের নিউজলেটারে যোগ দিন",
    newsletter_sub: "সৌন্দর্য টিপস, বিশেষ অফার, কোনও স্প্যাম নয়।",
    newsletter_placeholder: "আপনার ইমেল",
    newsletter_cta: "সাবস্ক্রাইব",
    copyright: "© {{year}} Fayriza. সর্বস্বত্ব সংরক্ষিত।",
    made_in: "ভারতে তৈরি",
  },
  home: {
    hero_eyebrow: "ভারতের প্রিমিয়াম স্যালন নেটওয়ার্ক",
    hero_title: "আপনার নিখুঁত স্যালন অভিজ্ঞতা আবিষ্কার করুন",
    hero_subtitle: "আপনার কাছাকাছি শীর্ষ রেটেড স্যালনে অ্যাপয়েন্টমেন্ট বুক করুন — বিলাসিতা, সুবিধা এবং যত্ন।",
    search_placeholder: "স্যালন, পরিষেবা বা স্টাইলিস্ট খুঁজুন…",
    search_cta: "স্যালন খুঁজুন",
    featured_salons: "বিশেষ স্যালন",
    browse_all: "সব দেখুন",
    view_all: "সব দেখুন",
    categories_title: "ক্যাটেগরি দেখুন",
    categories_sub: "প্রতিটি উপলক্ষের জন্য বাছাই করা পরিষেবা",
    why_title: "কেন Fayriza",
    why_sub: "সম্পূর্ণ একটি প্রিমিয়াম অভিজ্ঞতা",
    why_1_title: "যাচাইকৃত স্যালন",
    why_1_body: "প্রতিটি পার্টনার স্যালন হাতে বাছাই করা ও মান যাচাই করা।",
    why_2_title: "তাৎক্ষণিক বুকিং",
    why_2_body: "রিয়েল-টাইম উপলব্ধতা, সেকেন্ডে নিশ্চিত।",
    why_3_title: "নিরাপদ পেমেন্ট",
    why_3_body: "Razorpay-সমর্থিত, রিফান্ড-সুরক্ষিত লেনদেন।",
    why_4_title: "লয়্যালটি ও পুরস্কার",
    why_4_body: "প্রতিটি ভিজিটে পয়েন্ট অর্জন করুন, সুবিধার জন্য ব্যবহার করুন।",
    testimonials_title: "আমাদের কমিউনিটির প্রিয়",
    cta_title: "উজ্জ্বল হতে প্রস্তুত?",
    cta_sub: "হাজারো Fayriza সদস্যের সাথে যোগ দিন।",
    cta_btn: "শুরু করুন",
  },
  salons: {
    title: "সব স্যালন",
    subtitle: "আপনার কাছাকাছি প্রিমিয়াম পার্টনার স্যালন দেখুন",
    filter: "ফিল্টার",
    sort: "সাজান",
    sort_relevance: "প্রাসঙ্গিকতা",
    sort_rating: "সর্বোচ্চ রেটিং",
    sort_price_asc: "দাম: কম থেকে বেশি",
    sort_price_desc: "দাম: বেশি থেকে কম",
    sort_nearest: "নিকটতম",
    search_placeholder: "নাম বা এলাকা দিয়ে খুঁজুন…",
    categories_all: "সব",
    city_all: "সব শহর",
    price_range: "দামের পরিসর",
    open_now: "এখন খোলা",
    no_results_title: "আপনার ফিল্টারে কোনও স্যালন মেলেনি",
    no_results_sub: "একটি ফিল্টার সরিয়ে বা অন্য এলাকা খুঁজে দেখুন।",
    clear_filters: "ফিল্টার সরান",
    showing: "{{count}}টি স্যালন দেখানো হচ্ছে",
    loading: "স্যালন লোড হচ্ছে…",
    book_now: "এখনই বুক করুন",
    from: "থেকে",
    per_service: "প্রতি পরিষেবা",
    results: "ফলাফল",
    filters_title: "ফিল্টার",
    reset_all: "সব রিসেট করুন",
    category: "বিভাগ",
    min_rating: "সর্বনিম্ন রেটিং",
    any_rating: "যেকোন রেটিং",
    for_gender: "কার জন্য",
    gender_women: "মহিলা",
    gender_men: "পুরুষ",
    gender_unisex: "সবার জন্য",
    cat_bridal: "কনে",
    cat_spa: "স্পা",
  },
  salon: {
    book_now: "এখনই বুক করুন",
    message: "বার্তা",
    favourite: "প্রিয়",
    unfavourite: "প্রিয় থেকে সরান",
    share: "শেয়ার",
    directions: "দিকনির্দেশ",
    call: "কল",
    services: "পরিষেবা",
    stylists: "স্টাইলিস্ট",
    reviews: "রিভিউ",
    availability: "উপলব্ধতা",
    gallery: "গ্যালারি",
    about: "পরিচিতি",
    working_hours: "কাজের সময়",
    amenities: "সুবিধা",
    contact: "যোগাযোগ",
    overview: "সারসংক্ষেপ",
    location: "অবস্থান",
    reviews_count: "{{count}}টি রিভিউ",
    rating_out_of: "৫ এর মধ্যে {{rating}}",
    select_service: "বুক করতে একটি পরিষেবা নির্বাচন করুন",
    duration: "সময়কাল",
    minutes: "{{min}} মিনিট",
    open: "খোলা",
    closed: "বন্ধ",
    closes_at: "{{time}} এ বন্ধ হবে",
    opens_at: "{{time}} এ খুলবে",
  },
  booking: {
    title: "অ্যাপয়েন্টমেন্ট বুক করুন",
    step_services: "পরিষেবা",
    step_stylist: "স্টাইলিস্ট",
    step_datetime: "তারিখ ও সময়",
    step_review: "পর্যালোচনা",
    step_pay: "পেমেন্ট",
    select_services: "পরিষেবা নির্বাচন করুন",
    select_stylist: "স্টাইলিস্ট নির্বাচন করুন",
    any_stylist: "যেকোনো উপলব্ধ স্টাইলিস্ট",
    select_date: "তারিখ নির্বাচন করুন",
    select_time: "সময় নির্বাচন করুন",
    no_slots: "এই তারিখের জন্য কোনও স্লট উপলব্ধ নেই",
    try_other_date: "অন্য তারিখ দেখুন",
    confirm: "বুকিং নিশ্চিত করুন",
    cancel: "বুকিং বাতিল করুন",
    reschedule: "পুনঃনির্ধারণ",
    subtotal: "সাবটোটাল",
    discount: "ছাড়",
    tax: "কর ও ফি",
    total: "মোট",
    pay_now: "এখন পরিশোধ করুন",
    pay_at_salon: "স্যালনে পরিশোধ করুন",
    use_wallet: "ওয়ালেট ব্যবহার করুন",
    apply_offer: "অফার প্রয়োগ করুন",
    offer_placeholder: "কোড লিখুন",
    apply: "প্রয়োগ করুন",
    remove: "সরান",
    booking_confirmed: "বুকিং নিশ্চিত হয়েছে!",
    booking_cancelled: "বুকিং বাতিল হয়েছে",
    booking_ref: "বুকিং আইডি",
    when: "কখন",
    where: "কোথায়",
    who: "সঙ্গে",
    notes: "একটি নোট যোগ করুন (ঐচ্ছিক)",
    notes_placeholder: "অ্যালার্জি, পছন্দ…",
    upcoming: "আসন্ন",
    past: "অতীত",
    cancelled: "বাতিল",
    view_details: "বিস্তারিত দেখুন",
    download_receipt: "রসিদ ডাউনলোড করুন",
    rate_visit: "এই ভিজিটকে রেট দিন",
  },
  auth: {
    login_title: "আবার স্বাগতম",
    login_sub: "Fayriza-তে চালিয়ে যেতে সাইন ইন করুন",
    register_title: "অ্যাকাউন্ট তৈরি করুন",
    register_sub: "ভারতের প্রিমিয়াম স্যালন নেটওয়ার্কে যোগ দিন",
    email: "ইমেল",
    email_placeholder: "you@example.com",
    password: "পাসওয়ার্ড",
    password_placeholder: "কমপক্ষে ৮ অক্ষর",
    phone: "ফোন নম্বর",
    phone_placeholder: "১০-অঙ্কের মোবাইল নম্বর",
    name: "পুরো নাম",
    name_placeholder: "আপনার নাম",
    otp: "OTP লিখুন",
    otp_placeholder: "৬-অঙ্কের কোড",
    send_otp: "OTP পাঠান",
    verify_otp: "যাচাই করুন",
    resend_otp: "OTP পুনরায় পাঠান",
    resend_in: "{{s}} সেকেন্ডে পুনরায় পাঠান",
    login_cta: "সাইন ইন",
    register_cta: "অ্যাকাউন্ট তৈরি করুন",
    forgot_password: "পাসওয়ার্ড ভুলে গেছেন?",
    reset_password: "পাসওয়ার্ড রিসেট করুন",
    reset_sub: "আপনার ইমেল দিন, আমরা একটি রিসেট লিঙ্ক পাঠাব",
    reset_sent: "আপনার ইমেলে রিসেট লিঙ্ক পাঠানো হয়েছে",
    new_password: "নতুন পাসওয়ার্ড",
    confirm_password: "পাসওয়ার্ড নিশ্চিত করুন",
    social_login: "অথবা এর সাথে চালিয়ে যান",
    google: "Google",
    facebook: "Facebook",
    apple: "Apple",
    verify_email: "ইমেল যাচাই করুন",
    verify_email_sub: "আমরা {{email}}-এ একটি যাচাইকরণ লিঙ্ক পাঠিয়েছি",
    resend_email: "যাচাইকরণ ইমেল পুনরায় পাঠান",
    accept_terms: "আমি শর্তাবলী এবং গোপনীয়তা নীতিতে সম্মত",
    switch_to_register: "অ্যাকাউন্ট নেই?",
    switch_to_register_cta: "সাইন আপ করুন",
    switch_to_login: "ইতিমধ্যে অ্যাকাউন্ট আছে?",
    switch_to_login_cta: "সাইন ইন করুন",
    remember_me: "আমাকে মনে রাখুন",
    phone_or_email: "ফোন বা ইমেল",
    use_phone: "ফোন ব্যবহার করুন",
    use_email: "ইমেল ব্যবহার করুন",
  },
  profile: {
    title: "আমার প্রোফাইল",
    edit_profile: "প্রোফাইল সম্পাদনা করুন",
    change_password: "পাসওয়ার্ড পরিবর্তন করুন",
    avatar: "প্রোফাইল ছবি",
    upload_photo: "ছবি আপলোড করুন",
    name: "পুরো নাম",
    phone: "ফোন নম্বর",
    email: "ইমেল",
    dob: "জন্ম তারিখ",
    gender: "লিঙ্গ",
    gender_male: "পুরুষ",
    gender_female: "মহিলা",
    gender_other: "অন্যান্য",
    address: "ঠিকানা",
    city: "শহর",
    pincode: "পিনকোড",
    save: "পরিবর্তন সংরক্ষণ করুন",
    saved: "প্রোফাইল আপডেট হয়েছে",
    current_password: "বর্তমান পাসওয়ার্ড",
    current_password_placeholder: "বর্তমান পাসওয়ার্ড লিখুন",
    new_password: "নতুন পাসওয়ার্ড",
    new_password_placeholder: "কমপক্ষে ৮ অক্ষর",
    password_changed: "পাসওয়ার্ড সফলভাবে পরিবর্তিত হয়েছে",
  },
  dashboard: {
    title: "ড্যাশবোর্ড",
    welcome: "আবার স্বাগতম, {{name}}",
    upcoming_bookings: "আসন্ন বুকিং",
    no_upcoming: "কোনও আসন্ন অ্যাপয়েন্টমেন্ট নেই",
    book_a_salon: "একটি স্যালন বুক করুন",
    favourites: "প্রিয় স্যালন",
    no_favourites: "আপনি এখনও কোনও স্যালন প্রিয়তে যোগ করেননি",
    loyalty_points: "লয়্যালটি পয়েন্ট",
    wallet_balance: "ওয়ালেট ব্যালেন্স",
    recent_activity: "সাম্প্রতিক কার্যকলাপ",
    quick_actions: "দ্রুত পদক্ষেপ",
    view_all: "সব দেখুন",
    manage_membership: "সদস্যপদ পরিচালনা",
    top_up_wallet: "ওয়ালেটে টাকা যোগ করুন",
    refer_friend: "বন্ধুকে রেফার করুন",
  },
  common: {
    loading: "লোড হচ্ছে…",
    error: "কিছু ভুল হয়েছে",
    retry: "আবার চেষ্টা করুন",
    no_results: "কোনও ফলাফল পাওয়া যায়নি",
    search: "অনুসন্ধান",
    filter: "ফিল্টার",
    sort: "সাজান",
    view_all: "সব দেখুন",
    see_more: "আরও দেখুন",
    see_less: "কম দেখুন",
    back: "পিছনে",
    next: "পরবর্তী",
    previous: "পূর্ববর্তী",
    submit: "জমা দিন",
    cancel: "বাতিল",
    delete: "মুছুন",
    edit: "সম্পাদনা",
    save: "সংরক্ষণ",
    close: "বন্ধ",
    confirm: "নিশ্চিত করুন",
    continue: "চালিয়ে যান",
    yes: "হ্যাঁ",
    no: "না",
    skip: "এড়িয়ে যান",
    optional: "ঐচ্ছিক",
    required: "আবশ্যক",
    from: "থেকে",
    per: "প্রতি",
    to: "পর্যন্ত",
    and: "এবং",
    or: "বা",
    learn_more: "আরও জানুন",
    coming_soon: "শীঘ্রই আসছে",
    currency: "₹",
    minutes_short: "মি",
    hours_short: "ঘ",
    km: "কিমি",
    away: "দূরে",
    stars: "স্টার",
  },
  loyalty: {
    title: "Fayriza লয়্যালটি",
    subtitle: "প্রতিটি ভিজিটে পয়েন্ট অর্জন করুন, পুরস্কারের জন্য ব্যবহার করুন",
    points: "পয়েন্ট",
    available_points: "উপলব্ধ পয়েন্ট",
    total_earned: "মোট অর্জিত",
    total_redeemed: "মোট ব্যবহৃত",
    redeem: "ব্যবহার করুন",
    history: "পয়েন্ট ইতিহাস",
    rewards: "পুরস্কার",
    tier: "স্তর",
    how_it_works: "এটি কীভাবে কাজ করে",
    earn_title: "অর্জন",
    earn_body: "প্রতি ₹১০ খরচে ১ পয়েন্ট। Gold-এ ২×, Platinum-এ ৩×।",
    redeem_title: "ব্যবহার",
    redeem_body: "ওয়ালেট ক্রেডিট, ফ্রি পরিষেবা বা পার্টনার সুবিধার জন্য পয়েন্ট ব্যবহার করুন।",
    empty_history: "এখনও কোনও পয়েন্ট কার্যকলাপ নেই",
    empty_rewards: "এই মুহূর্তে কোনও পুরস্কার উপলব্ধ নেই",
  },
  wallet: {
    title: "Fayriza ওয়ালেট",
    subtitle: "একবার টপ আপ করুন, নির্বিঘ্নে বুক করুন",
    balance: "ব্যালেন্স",
    available: "উপলব্ধ",
    topup: "টপ আপ",
    topup_cta: "টাকা যোগ করুন",
    topup_amount: "পরিমাণ",
    history: "লেনদেন ইতিহাস",
    empty_history: "এখনও কোনও লেনদেন নেই",
    credit: "ক্রেডিট",
    debit: "ডেবিট",
    refund: "রিফান্ড",
  },
  membership: {
    eyebrow: "বিশেষ অ্যাক্সেস",
    hero_title: "Fayriza সদস্যপদ প্ল্যান",
    hero_sub: "ভারতের ৫০০+ প্রিমিয়াম স্যালনে বিশেষ ছাড়, অগ্রাধিকার বুকিং এবং বিলাসবহুল সুবিধা উপভোগ করুন।",
    plans: "সদস্যপদ প্ল্যান",
    subscribe: "সাবস্ক্রাইব",
    cancel: "সদস্যপদ বাতিল করুন",
    current: "বর্তমান প্ল্যান",
    gold: "Gold",
    silver: "Silver",
    platinum: "Platinum",
    per_year: "/বছর",
    per_month_approx: "≈ ₹{{amount}}/মাস",
    cancel_anytime: "যেকোনো সময় বাতিল করুন",
    choose_title: "আপনার প্ল্যান বেছে নিন",
    choose_sub: "সব প্ল্যান বার্ষিক বিল করা হয়। একটি প্ল্যান বেছে নিন এবং তাৎক্ষণিক সক্রিয় করতে নিশ্চিত করুন।",
    most_popular: "সবচেয়ে জনপ্রিয়",
    get_plan: "{{plan}} নিন",
    selected_proceed: "নির্বাচিত — পেমেন্টে এগিয়ে যান →",
    processing: "প্রক্রিয়াকরণ হচ্ছে…",
    current_plan_label: "✓ বর্তমান প্ল্যান",
    welcome_back: "আবার স্বাগতম, {{name}}!",
    member_label: "Fayriza {{tier}} সদস্য",
    expires_in: "{{days}} দিনে মেয়াদ শেষ",
    renews_on: "{{date}} এ নবায়ন হবে",
    your_discount: "আপনার ছাড়",
    off_all: "সব পরিষেবায় ছাড়",
    expiring_warn: "আপনার সদস্যপদ শীঘ্রই শেষ হবে। ছাড় ধরে রাখতে এখনই নবায়ন করুন।",
    feature_comparison: "সম্পূর্ণ বৈশিষ্ট্য তুলনা",
    feature: "বৈশিষ্ট্য",
    benefits_500: "৫০০+ পার্টনার স্যালন",
    benefits_instant: "তাৎক্ষণিক সক্রিয়করণ",
    benefits_cancel: "যেকোনো সময় বাতিল",
    benefits_refund: "৭-দিনের মানি ব্যাক",
    faq_title: "প্রায়শই জিজ্ঞাসিত প্রশ্ন",
    faq_cancel_q: "আমি কি আমার সদস্যপদ বাতিল করতে পারি?",
    faq_cancel_a: "হ্যাঁ। আপনি আপনার ড্যাশবোর্ড থেকে যেকোনো সময় বাতিল করতে পারেন। আপনার বিলিং সময়কাল শেষ না হওয়া পর্যন্ত আপনার সুবিধা চলতে থাকবে।",
    faq_all_salons_q: "ছাড় কি সব স্যালনে প্রযোজ্য?",
    faq_all_salons_a: "হ্যাঁ — ছাড় ভারত জুড়ে ৫০০+ যাচাইকৃত Fayriza পার্টনার স্যালনে স্বয়ংক্রিয়ভাবে প্রযোজ্য।",
    faq_refund_q: "৭-দিনের মানি ব্যাক গ্যারান্টি কী?",
    faq_refund_a: "সক্রিয়করণের ৭ দিনের মধ্যে সন্তুষ্ট না হলে, আমরা কোনও প্রশ্ন ছাড়াই আপনার সদস্যপদ ফি সম্পূর্ণ ফেরত দেব।",
    faq_upgrade_q: "আমি কি আমার প্ল্যান আপগ্রেড করতে পারি?",
    faq_upgrade_a: "হ্যাঁ। আপনি যেকোনো সময় আপগ্রেড করতে পারেন। অবশিষ্ট সময়ের জন্য আনুপাতিক পার্থক্য নেওয়া হবে।",
    activated: "🎉 Fayriza {{plan}} সক্রিয় হয়েছে!",
    subscribe_failed: "সাবস্ক্রিপশন ব্যর্থ হয়েছে। অনুগ্রহ করে আবার চেষ্টা করুন।",
  },
  shop: {
    eyebrow: "Fayriza শপ",
    hero_title: "প্রিমিয়াম সৌন্দর্য ও গ্রুমিং পণ্য",
    hero_sub: "বাছাই করা পেশাদার মানের অপরিহার্য পণ্য, আপনার দরজায় পৌঁছে দেওয়া।",
    search_placeholder: "পণ্য খুঁজুন…",
    categories: "ক্যাটেগরি",
    all_products: "সব পণ্য",
    add_to_cart: "কার্টে যোগ করুন",
    added: "যোগ হয়েছে ✓",
    out_of_stock: "স্টক নেই",
    checkout: "চেকআউট",
    cart: "কার্ট",
    cart_empty: "আপনার কার্ট খালি",
    cart_empty_sub: "কেনাকাটা শুরু করে এটি পূর্ণ করুন",
    products: "পণ্য",
    orders: "আমার অর্ডার",
    no_orders: "এখনও কোনও অর্ডার নেই",
    order_ref: "অর্ডার আইডি",
    order_status: "স্ট্যাটাস",
    order_placed: "স্থাপিত",
    order_shipped: "পাঠানো হয়েছে",
    order_delivered: "ডেলিভারি হয়েছে",
    order_cancelled: "বাতিল",
    qty: "পরিমাণ",
    remove: "সরান",
    subtotal: "সাবটোটাল",
    shipping: "শিপিং",
    tax: "কর",
    total: "মোট",
    proceed_checkout: "চেকআউটে এগিয়ে যান",
    shipping_address: "শিপিং ঠিকানা",
    place_order: "অর্ডার করুন",
    continue_shopping: "কেনাকাটা চালিয়ে যান",
    product_details: "পণ্যের বিবরণ",
    description: "বিবরণ",
    specifications: "স্পেসিফিকেশন",
    you_may_like: "আপনার পছন্দ হতে পারে",
    related: "সম্পর্কিত পণ্য",
  },
  academy: {
    eyebrow: "Fayriza অ্যাকাডেমি",
    hero_title: "ভারতের সেরা স্টাইলিস্টদের থেকে শিখুন",
    hero_sub: "প্রত্যয়িত বিশেষজ্ঞদের দ্বারা শেখানো পেশাদার সৌন্দর্য ও গ্রুমিং কোর্স। নিজের গতিতে শিখুন, সার্টিফিকেট অর্জন করুন এবং আপনার ক্যারিয়ার শুরু করুন।",
    search_placeholder: "কোর্স বা প্রশিক্ষক খুঁজুন…",
    stats_courses: "বিশেষজ্ঞ কোর্স",
    stats_students: "নথিভুক্ত শিক্ষার্থী",
    stats_rating: "গড় রেটিং",
    stats_certificate: "সার্টিফিকেট অন্তর্ভুক্ত",
    all: "সব কোর্স",
    makeup: "মেকআপ",
    hair: "চুল",
    skin: "ত্বক",
    nails: "নখ",
    grooming: "গ্রুমিং",
    courses: "কোর্স",
    course: "কোর্স",
    enroll: "এখনই নথিভুক্ত হন",
    enrolled: "নথিভুক্ত",
    modules: "মডিউল",
    instructor: "প্রশিক্ষক",
    duration: "সময়কাল",
    level: "স্তর",
    level_beginner: "প্রাথমিক",
    level_intermediate: "মধ্যবর্তী",
    level_advanced: "উন্নত",
    certificate: "সার্টিফিকেট",
    no_courses: "আপনার ফিল্টারে কোনও কোর্স মেলেনি",
    my_enrollments: "আমার কোর্স",
    continue_learning: "শেখা চালিয়ে যান",
    completed: "সম্পন্ন",
  },
  notifications: {
    title: "বিজ্ঞপ্তি",
    empty: "সব দেখা হয়ে গেছে",
    empty_sub: "এই মুহূর্তে কোনও নতুন বিজ্ঞপ্তি নেই",
    mark_all_read: "সব পঠিত হিসাবে চিহ্নিত করুন",
    just_now: "এইমাত্র",
    minutes_ago: "{{n}} মিনিট আগে",
    hours_ago: "{{n}} ঘন্টা আগে",
    days_ago: "{{n}} দিন আগে",
  },
  ai: {
    title: "Fayriza AI উপদেষ্টা",
    subtitle: "AI-চালিত ব্যক্তিগত সৌন্দর্য সুপারিশ।",
    placeholder: "ত্বক, চুল, মেকআপ সম্পর্কে যেকোনো কিছু জিজ্ঞাসা করুন…",
    send: "পাঠান",
    examples_title: "জিজ্ঞাসা করে দেখুন",
    ex_1: "আমার মুখের আকারের জন্য সেরা হেয়ারকাট?",
    ex_2: "তৈলাক্ত ত্বকের জন্য স্কিনকেয়ার রুটিন",
    ex_3: "২০২৬ এর ব্রাইডাল মেকআপ ট্রেন্ড",
    thinking: "ভাবছে…",
    disclaimer: "পরামর্শগুলি তথ্যমূলক। চিকিৎসা সংক্রান্ত বিষয়ে একজন পেশাদারের সাথে পরামর্শ করুন।",
  },
  marketing: {
    about: {
      eyebrow: "আমাদের গল্প",
      title: "সৌন্দর্য, নতুনভাবে কল্পিত",
      sub: "Fayriza একটি সহজ ধারণা থেকে জন্ম নিয়েছে — ভারত তার শিল্পের মতোই পরিশীলিত একটি স্যালন বুকিং অভিজ্ঞতার যোগ্য।",
      mission_title: "আমাদের মিশন",
      mission_body: "একটি নির্বিঘ্ন, বিশ্বস্ত এবং বিলাসবহুল প্ল্যাটফর্মের মাধ্যমে লক্ষ লক্ষ সৌন্দর্য প্রেমীকে ভারতের সেরা স্যালনগুলির সাথে সংযুক্ত করা।",
      vision_title: "আমাদের দৃষ্টিভঙ্গি",
      vision_body: "একটি বিশ্ব যেখানে প্রত্যেকের হাতের নাগালে মানসম্পন্ন সৌন্দর্য ও সুস্থতা পরিষেবা রয়েছে।",
      values_title: "আমাদের মূল্যবোধ",
      value_1_title: "মান সর্বাগ্রে",
      value_1_body: "প্রতিটি পার্টনার স্যালন যাচাই করা এবং আমাদের প্রিমিয়াম মানদণ্ডে রাখা।",
      value_2_title: "গ্রাহক-কেন্দ্রিক",
      value_2_body: "আপনার অভিজ্ঞতা আমাদের পথপ্রদর্শক — বুকিং থেকে পরবর্তী যত্ন পর্যন্ত।",
      value_3_title: "পার্টনারদের ক্ষমতায়ন",
      value_3_body: "আমাদের স্যালন ও স্টাইলিস্টরা যখন বেড়ে ওঠেন, তখন আমরাও বেড়ে উঠি।",
      cta_title: "গল্পের অংশ হোন",
      cta_sub: "আজই Fayriza কমিউনিটিতে যোগ দিন।",
    },
    how_it_works: {
      eyebrow: "এটি কীভাবে কাজ করে",
      title: "তিন ধাপে বুক করুন",
      sub: "প্রিমিয়াম সৌন্দর্য, অনুমান ছাড়াই।",
      step_1_title: "আবিষ্কার",
      step_1_body: "আপনার কাছাকাছি যাচাইকৃত স্যালন, পরিষেবা এবং স্টাইলিস্ট দেখুন।",
      step_2_title: "বুক",
      step_2_body: "আপনার সুবিধামতো সময় বেছে নিন — তাৎক্ষণিক নিশ্চিত।",
      step_3_title: "উপভোগ",
      step_3_body: "প্যাম্পার হোন। আপনার ভিজিট রেট দিন। পুরস্কার অর্জন করুন।",
      faq_title: "দ্রুত প্রশ্ন",
    },
    partners: {
      eyebrow: "স্যালন মালিকদের জন্য",
      title: "Fayriza-এর সাথে বৃদ্ধি পান",
      sub: "নতুন গ্রাহকদের কাছে পৌঁছান, খালি চেয়ার পূরণ করুন এবং একটি আধুনিক স্যালন পরিচালনা করুন।",
      benefit_1_title: "আরও গ্রাহক",
      benefit_1_body: "ভারতের বৃহত্তম প্রিমিয়াম সৌন্দর্য দর্শকদের কাছে পৌঁছান।",
      benefit_2_title: "স্মার্ট বুকিং",
      benefit_2_body: "একটি ড্যাশবোর্ড থেকে সময়সূচী, কর্মী এবং পরিষেবা পরিচালনা করুন।",
      benefit_3_title: "তাৎক্ষণিক পেমেন্ট",
      benefit_3_body: "নিরাপদ, দ্রুত পেআউট — ম্যানুয়াল তাড়ানোর ঝামেলা নেই।",
      cta: "পার্টনার হোন",
    },
    stylists: {
      eyebrow: "স্টাইলিস্টদের জন্য",
      title: "আপনার ক্লায়েন্টেল তৈরি করুন",
      sub: "আপনার কাজ প্রদর্শন করুন, পরিচিতি পান এবং আপনার ক্যারিয়ার গড়ে তুলুন।",
      cta: "স্টাইলিস্ট হিসাবে আবেদন করুন",
    },
    careers: {
      eyebrow: "ক্যারিয়ার",
      title: "সৌন্দর্যের ভবিষ্যৎ গড়ুন",
      sub: "আমরা একটি ছোট দল, বড় কিছু তৈরি করছি। যোগ দিতে চান?",
      openings_title: "খোলা পদ",
      no_openings: "এই মুহূর্তে কোনও পদ খালি নেই। careers@fayriza.com-এ আমাদের একটি বার্তা পাঠান।",
    },
    contact: {
      eyebrow: "যোগাযোগ করুন",
      title: "আমরা আপনার কথা শুনতে চাই",
      sub: "প্রশ্ন, মতামত বা পার্টনারশিপের ধারণা — আমরা শোনার জন্য প্রস্তুত।",
      name: "আপনার নাম",
      email: "আপনার ইমেল",
      message: "বার্তা",
      send: "বার্তা পাঠান",
      sent: "ধন্যবাদ — আমরা ২৪ ঘন্টার মধ্যে উত্তর দেব।",
      support_email: "সহায়তা",
      partners_email: "পার্টনার",
      media_email: "মিডিয়া",
    },
    faq: {
      eyebrow: "সহায়তা",
      title: "প্রায়শই জিজ্ঞাসিত প্রশ্ন",
      sub: "সাধারণ প্রশ্নের দ্রুত উত্তর।",
    },
    legal: {
      privacy_title: "গোপনীয়তা নীতি",
      terms_title: "সেবার শর্তাবলী",
      refund_title: "রিফান্ড নীতি",
      last_updated: "সর্বশেষ আপডেট {{date}}",
    },
  },
  errors: {
    network: "নেটওয়ার্ক ত্রুটি — আপনার সংযোগ পরীক্ষা করুন",
    unauthorised: "চালিয়ে যেতে অনুগ্রহ করে সাইন ইন করুন",
    forbidden: "আপনার এতে অ্যাক্সেস নেই",
    not_found: "আপনি যা খুঁজছেন তা আমরা পাইনি",
    server: "সার্ভার ত্রুটি — অনুগ্রহ করে পরে আবার চেষ্টা করুন",
    validation: "অনুগ্রহ করে চিহ্নিত ক্ষেত্রগুলি পরীক্ষা করুন",
    generic: "কিছু ভুল হয়েছে",
    page_not_found_title: "পৃষ্ঠা পাওয়া যায়নি",
    page_not_found_sub: "আপনি যে পৃষ্ঠাটি খুঁজছেন তা সরানো হয়েছে বা আর বিদ্যমান নেই।",
    go_home: "হোমে যান",
  },
};

export default bn;
